export default __webpack_public_path__ + "static/media/Lato-Black.0f56360f.ttf";